import React, { useRef, useState } from "react"

import classNames from "@utils/classnames"

import { useScrollEvent } from "@src/utils/hooks"
import Clickable from "../clickable"
import Icon from "../icon"
import * as styles from "./nav.module.scss"
import logoImg from "@images/2x/33aa.png"
import classnames from "@utils/classnames"
import { handleClickAnchor } from "@src/utils/common"

const defaultLinks = [
  { title: "NEWS", href: "/#news" },
  { title: "活动介绍", href: "/#info" },
  { title: "玩法", href: "/#manual" },
  { title: "舞台", href: "/#stage" },
  { title: "嘉宾", href: "/#guests" },
  { title: "现场贩售", href: "/#sale" },
  { title: "志愿者", href: "/#entries" },
]

const Nav = React.memo(({ current, links = defaultLinks, ticketUrl }) => {
  const [dropdownVisble, setDropdownVisible] = useState(false)
  const [visible, setVisible] = useState(true)
  const prevScrollTopRef = useRef(-1)

  const handleItemClick = (e) => {
    setDropdownVisible(false)
    handleClickAnchor(e)
  }

  useScrollEvent(() => {
    const scrollTop = window.scrollY
    const prevTop = prevScrollTopRef.current
    if (scrollTop <= 500) {
      setVisible(true)
      return
    }
    if (prevTop >= 0) {
      setVisible(scrollTop < prevTop)
    }
    prevScrollTopRef.current = scrollTop
  })

  return (
    <nav
      className={classNames(styles.nav, {
        [styles.isDropdown]: dropdownVisble,
        [styles.isHide]: !visible,
      })}
    >
      <Clickable
        className={styles.dropDownMask}
        onClick={() => {
          setDropdownVisible(false)
        }}
      />
      <div className={styles.navCenter}>
        <div className={styles.logoContainer}>
          <Clickable
            appNavTo="https://www.gcores.com"
            className={styles.gMainLogo}
          >
            <Icon icon="g" />
          </Clickable>
          <div>
            <img src={logoImg} className={styles.logo} alt="gfusion logo" />
          </div>
          <div className={styles.locationLinks}>
            {["gz", "cd"].map((loc) => {
              return (
                <Clickable
                  key={loc}
                  to={`/${loc}/`}
                  className={classnames({
                    [styles.activeLink]: current === loc,
                  })}
                >
                  {loc === "gz" ? "广州站" : "成都站"}
                </Clickable>
              )
            })}
          </div>
        </div>
        <div className={styles.right}>
          {links?.length > 0 && (
            <Clickable
              className={styles.menuBtn}
              onClick={() => {
                setDropdownVisible((prev) => !prev)
              }}
            >
              {dropdownVisble ? <Icon icon="close" /> : <Icon icon="burger" />}
            </Clickable>
          )}
          {links?.length > 0 && (
            <div className={styles.menu}>
              <ul>
                {links.map(({ title, href }) => {
                  return (
                    <li key={title}>
                      <Clickable
                        newWindow={false}
                        to={href}
                        onClick={handleItemClick}
                      >
                        {title}
                      </Clickable>
                    </li>
                  )
                })}
              </ul>
              {ticketUrl && (
                <div className={styles.menuActions}>
                  <Clickable appNavTo={ticketUrl} className={styles.enrollBtn}>
                    立即购票
                  </Clickable>
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    </nav>
  )
})

export default Nav
